import React, { memo, useCallback, useMemo, useState } from "react";
import ArticleSearchContainer from "../../containers/ArticleSearchContainer";
import FormItemsContainer from "../../containers/FormItemsContainer";
import { handleChangeIds, handleCheckAll, countHits } from '../../../utils/checkBoxFunc';
import { ModalWindow, Modal } from "../../../components/Modal";
import SfcCheckBox from "../../../components/SfcCheckBox";
import ExtendedAreaCheckBoxList from "../common/ExtendedAreaCheckBoxList";

export const AreaSearcher = () => {
  const { areaIds, aggs, setAreaIds, search, searchDeps } = ArticleSearchContainer.useContainer();
  const { items } = FormItemsContainer.useContainer();

  const stateAndDispatch = {
    ids: areaIds, 
    aggs: aggs.area_count.area, 
    setIds: setAreaIds, 
  };

  const checkedNames = useMemo(() => {
    let names = [];
    ["domestic", "abroad"].forEach(v => {
        if (items.areas[v] != undefined) {
          names = [
            ...names,
            items.areas[v].regions
            .map(item => item.opts)
            .reduce((pre,current) => {pre.push(...current);return pre},[]) // 多次元配列を一次元配列化
            .filter(item => areaIds.includes(item.value))
            .map(item => `${item.label}(${countHits(aggs.area_count.area.buckets, item.value)})`)
            .join(' , ')
          ];
        }
      }
    );
    return names;
  }, [areaIds]);

  const onSearch = useCallback(() => {
    search();
  }, [...searchDeps]);

  return (
    <ModalWindow>
      {(open, close, isActive) => (
        <>
          <h5>活動場所</h5>
          <div>
            <ExtendedAreaCheckBoxList />
            <div className='selectedAreas'>
              <span className="isChecked">{checkedNames}</span>
            </div>
            <button onClick={open} className='p_btn isMain'>
              エリアを変更する
            </button>
            <Modal
              isActive={isActive}
              closeModal={close}
            >
              <AreaSearchModal
                searchDeps={searchDeps}
                closeModal={close}
                search={onSearch}
                items={items}
                {...stateAndDispatch}
              />
            </Modal>
          </div>
        </>
      )}
    </ModalWindow>
  )
};

export const AreaSearchModal = memo(({
  searchDeps,
  closeModal,
  search,
  items,
  ...other
}) => {
  const [isTabDomestic, setIsTabDomestic] = useState(true);

  const toggleDomesticTab = useCallback(bool => {
    setIsTabDomestic(bool)
  }, [isTabDomestic])

  const fetchSearch = useCallback(() => {
    closeModal();
    search();
  }, [...searchDeps]);

  return (
    <div className='m_searchAreaModal jsSearchCancel searchAreaBoxWrap'>
      <div className="m_modalBox searchAreaBox">
        <DomesticAbroadSwitcher 
          isTabDomestic={isTabDomestic}
          toggleDomesticTab={toggleDomesticTab}
          items={items}
        />
        <LargeAreaList 
          isTabDomestic={isTabDomestic}
          {...isTabDomestic ? {...items.areas.domestic} : {...items.areas.abroad}} 
          {...other}
        />
        <SearchBtn 
          search={fetchSearch}
        />
      </div>
    </div>
  )
});

const LargeAreaList = memo(({
  isTabDomestic,
  name, 
  regions, 
  all_check_ids, 
  ...other
}) => {
  const onCheckAll = useCallback(() => {
    const allChecked = all_check_ids.every(i => other.ids.includes(i));
    handleCheckAll(allChecked, all_check_ids, other.ids, other.setIds);
  }, [other.ids]);

  return (
    <div className='areaList'>
      <SfcCheckBox
        label={`${name}を全て選択`}
        checked={all_check_ids.every(i => other.ids.includes(i))}
        onChangeValue={onCheckAll}
      />
      <ul className={`${isTabDomestic ? 'domestic' : 'abroad'}List`}>
        {regions.map(region => {
          return (
            <MiddleAreaList
              key={region.name}
              opts={region.opts}
              name={region.name}
              {...other}
            />
          )
        })}
      </ul>
    </div>
  )
})

const MiddleAreaList = memo(({
  opts, 
  name, 
  ...other
}) => {
  const onCheckAll = useCallback(() => {
    const allCheckIds = opts.map(opt => opt.value);
    const allChecked = allCheckIds.every(i => other.ids.includes(i));
    handleCheckAll(allChecked, allCheckIds, other.ids, other.setIds)
  }, [other.ids]);

  return (
    <>
      <li className='modalCheckAll'>
        <SfcCheckBox
          label={`${name}を全て選択`}
          checked={opts.map(opt => opt.value).every(i => other.ids.includes(i))}
          onChangeValue={onCheckAll}
        />
      </li>
      <ul>
        {opts.filter(opt => countHits(other.aggs.buckets, opt.value) !== 0)
          .map((opt) => {
            return (
              <li key={`check-${opt.value}`} className='checkList'>
                <SfcCheckBox
                  value={opt.value}
                  label={`${opt.label}(${countHits(other.aggs.buckets, opt.value)})`}
                  checked={other.ids.includes(opt.value)}
                  onChangeValue={handleChangeIds(other.ids, other.setIds)}
                />
              </li>
            )
          }
        )}
      </ul>
    </>
  )
})

const DomesticAbroadSwitcher = memo(({ isTabDomestic, toggleDomesticTab, items}) => {
  const isAbroadPresence = (items.areas.abroad != undefined);
  return (
    <>
      <div className="modalTitle">活動場所を選択</div>
      <div className="modalTop">
        <ul className="p_tabs">
          <li className={isTabDomestic ? 'active' : ''} onClick={() => toggleDomesticTab(true)}><span>国内から選択する</span></li>
          {(() => {
            if (isAbroadPresence) {
              return <li className={isTabDomestic ? '' : 'active'} onClick={() => toggleDomesticTab(false)}><span>海外から選択する</span></li>;
            }
          })()}
        </ul>
      </div>
    </>
  )
});

const SearchBtn = memo(({ search }) => {
  return (
    <div className='modalBtn'>
      <button 
        className='p_btn isLarge isMain jsModalSearch' 
        onClick={search}
      >
        選択する
      </button>
    </div>
  )
});